module.exports = __webpack_public_path__ + "static/img/rank_90.a9a9e7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_90.png
// module id = csFs
// module chunks = 1